<template>
<div>
  <breadcrumb :items="[{ text: 'Usuários', to: '/usuarios' }, { text: isEditing() ? form.name : 'Cadastrar usuário', active: true }]" />
  <loading :loading="isLoading" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <div class="row">
      <div class="col-sm-6">
        <b-form-group label="Nome *">
          <b-form-input v-model="form.name" v-validate="'required'" name="name" />
          <field-error :msg="veeErrors" field="name" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Email *">
          <b-form-input v-model="form.email" v-validate="'email|required'" name="email" />
          <field-error :msg="veeErrors" field="email" />
          <div class="text-right" v-if="isEditing()">
            <a class="pointer" @click="changePassword">Alterar senha</a>
          </div>
        </b-form-group>
      </div>
    </div>
    <div class="row" v-if="isAdmin">
      <div class="col-sm-12">
        <b-form-group label="Perfil de usuário *">
          <b-form-radio-group v-model="form.roles[0]" :options="tipos_de_usuario" v-validate="'required'" name="roles" />
          <field-error :msg="veeErrors" field="roles" />
        </b-form-group>
      </div>
      <div class="col-sm-12" v-if="form.roles[0] == 'client'">
        <b-form-group label="Representante comercial relacionado *">
          <form-entity-select type="sellers" :form="form" field="seller" />
        </b-form-group>
      </div>
      <div class="col-sm-6" v-show="form.roles[0] == 'manager'">
        <b-form-group label="Rede *">
          <form-entity-select type="organizations" :form="form" field="organization" />
        </b-form-group>
      </div>
      <div class="col-sm-6" v-show="form.roles[0] == 'supplier'">
        <b-form-group label="Fornecedor *">
          <form-entity-select type="suppliers" :form="form" field="supplier" />
        </b-form-group>
      </div>
    </div>
    <div v-if="!isAdmin && isLink" class="row">
      <div class="col-sm-12">
        <b-form-group label="Perfil de usuário *">
          <b-form-radio-group v-model="form.roles[0]" :options="tipos_de_usuario_link" v-validate="'required'" name="roles" />
          <field-error :msg="veeErrors" field="roles" />
        </b-form-group>
      </div>
    </div>
    <div v-if="form.roles[0] == 'client'" class="row">
      <div class="col-sm-6">
        <b-form-group v-if="form.roles[0] == 'client'" label="Categoria *">
          <b-form-select v-model="form.category" v-validate="'required'" name="category" :options="categorias_de_clientes" />
          <field-error :msg="veeErrors" field="category" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="CPF/CNPJ *">
          <b-form-input v-model="form.cnpj" v-validate="'required'" name="cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" />
          <field-error :msg="veeErrors" field="cnpj" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Inscrição estadual">
          <b-form-input v-model="form.state_registration" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Atividade principal">
          <b-form-input v-model="form.main_activity" name="main_activity" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Endereço *">
          <span v-if="form.address" class="text-black">{{form.address.description}}</span>
          <location :cb="setAddress" :current_address="form.address" :autoload="false" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Telefone *">
          <b-form-input v-model="form.phone" v-validate="'required'" name="phone" placeholder="(99) 99999-9999" v-mask="['(##) ####-####', '(##) #####-####']" />
          <field-error :msg="veeErrors" field="phone" />
        </b-form-group>
      </div>
    </div>
    <div class="row gray" v-if="showPasswordFields">
      <div class="col-sm-6">
        <b-form-group label="Senha *">
          <b-form-input v-model="form.password" type="password" v-validate="'required'" name="pass" />
          <field-error :msg="veeErrors" field="pass" />
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group label="Confirmar senha *">
          <b-form-input v-model="form.password_confirmation" type="password" v-validate="'required'" name="pass_confirmation" />
          <field-error :msg="veeErrors" field="pass_confirmation" />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <pictures-upload :form="form" :error="error" field="image" url="uploads/images" />
      </div>
    </div>
    <form-submit :errors="error" :sending="isSending" />
  </b-form>
</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import FormSubmit from '@/components/FormSubmit'
import PicturesUpload from '@/components/PicturesUpload'
import FieldError from '@/components/FieldError'
import FormEntitySelect from '@/components/FormEntitySelect'
import tipos_de_usuario from '@/data/tipos-de-usuario.json'
import Location from '@/components/Location'
import categorias_de_clientes from '@/data/categorias-de-clientes.json'

export default {

  name: 'UserForm',
  computed: {
    showPasswordFields() {
      return !this.isEditing() || this.show_password
    }
  },
  data() {
    return {
      categorias_de_clientes,
      show_password: false,
      tipos_de_usuario: tipos_de_usuario,
      tipos_de_usuario_link: [{ "text": "Cliente", "value": "client" }],
      form: {
        email: null,
        category: '',
        password: '',
        password_confirmation: '',
        name: '',
        image: {},
        roles: [],
        organization: null,
        supplier: null,
        seller: null,
        cnpj:'',
        address: null,
        phone: '',
        main_activity: '',
        state_registration: '',
      },
    }
  },
  created() {
    if (this.isEditing()) {
      this.edit(this.$route.params.id)
    } else if (this.$route.params.role == 'client') {
      this.form.roles[0] = 'client'
    }
  },
  methods: {
    edit(id) {
      this.isLoading = true
      axios.get('users/' + id).then(response => {
        this.apiDataToForm(this.form, response.data)
        this.isLoading = false
      }).catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false
          axios({
            method: (this.isEditing() ? 'PUT' : 'POST'),
            url: (this.isEditing() ? 'users/' + this.$route.params.id : 'users'),
            data: this.form
          }).then(resp => {
            var user = resp.data
            if (user && user._id) {
              if (user._id == this.currentUser._id) {
                this.$store.dispatch('login', user)
              }
              if (this.isA('client')) {
                this.$router.replace('/painel')
              } else {
                this.$router.replace('/usuarios')
              }

            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    },
    setAddress(address) {
      this.form.address = address
    },
    changePassword() {
      this.show_password = !this.show_password
    }
  },
  components: {
    Loading,
    FormSubmit,
    FieldError,
    FormEntitySelect,
    PicturesUpload,
    Location
  }

};
</script>
